<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Total Kontak</h5>
                        <h3>{{ stats.total_contacts || 0 }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Kontak Aktif</h5>
                        <h3>{{ stats.active_contacts || 0 }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Total Terkirim</h5>
                        <h3>{{ stats.total_sent || 0 }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Total Dibaca</h5>
                        <h3>{{ stats.total_read || 0 }}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4">
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Total Dibalas</h5>
                        <h3>{{ stats.total_replied || 0 }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Total Gagal</h5>
                        <h3>{{ stats.total_failed || 0 }}</h3>
                    </div>
                </div>
            </div>
            <div class="col-md-3">
                <div class="card text-center">
                    <div class="card-body">
                        <h5 class="card-title">Kontak Selesai</h5>
                        <h3>{{ stats.completed_contacts || 0 }}</h3>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-group">
            <label>Range:</label>
            <select v-model="range" @change="loadStats" class="form-control" style="width: 200px; display: inline-block; margin-left: 10px;">
                <option value="week">Minggu Ini</option>
                <option value="month">Bulan Ini</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            stats: {},
            range: 'month'
        };
    },
    mounted() {
        this.loadStats();
    },
    methods: {
        async loadStats() {
            try {
                const response = await this.$store.dispatch("followup/followup_stats", { range: this.range });
                this.stats = response.data.data.stats || {};
            } catch (err) {
                this.$toast.error("Gagal memuat statistik");
            }
        }
    }
};
</script>


